// Adiciona o evento de clique aos botões do carrossel de navegação
export const addThumbBtnsClickHandlers = (emblaApi, thumbEmblaApi) => {
    const thumbSlides = thumbEmblaApi.slideNodes();
    thumbSlides.forEach((thumbSlide, index) => {
        thumbSlide.addEventListener('click', () => emblaApi.scrollTo(index), false);
    });
};

// Sincroniza o estado ativo entre os dois carrosséis

/* export const addToggleThumbBtnsActive = (emblaApi, thumbEmblaApi) => {
    const toggleThumbActive = () => {
        const selected = emblaApi.selectedScrollSnap();
        const thumbSlides = thumbEmblaApi.slideNodes();
        thumbSlides.forEach((thumbSlide, i) => {
            thumbSlide.classList.toggle('embla__dot--selected', i === selected);
        });
        
        thumbEmblaApi.scrollTo(selected);
    };

    emblaApi.on('select', toggleThumbActive).on('reInit', toggleThumbActive);
    toggleThumbActive();
}; */

export const addToggleThumbBtnsActive = (emblaApi, thumbEmblaApi) => {
    const onSelect = () => {
        const selectedIndex = emblaApi.selectedScrollSnap();

        // PRIMEIRO, leva o thumbnail selecionado para a vista.
        // O Embla é inteligente o suficiente para não rolar se não for preciso.
        thumbEmblaApi.scrollTo(selectedIndex);

        // DEPOIS, atualiza as classes de todos os thumbnails.
        const thumbSlides = thumbEmblaApi.slideNodes();
        thumbSlides.forEach((thumbSlide, i) => {
            thumbSlide.classList.toggle('embla__dot--selected', i === selectedIndex);
        });
    };

    emblaApi.on('select', onSelect);
    emblaApi.on('reInit', onSelect);
    onSelect(); // Roda na inicialização para sincronizar o estado inicial
};